var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005741",
    d: "M15.804 15.047v1.86H8.126c.106-1.224.501-2.086 1.868-3.298l5.81-4.956v4.349h2.091V5H6.002v3.989h2.091V7.09h6.318l-5.782 4.934l-.013.013C6.193 14.183 6 15.915 6 17.955V19h11.895v-3.953z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeta);
export default __webpack_public_path__ + "static/media/zeta.9a4eeb05c56fbe60cecc2fb64d1b7cb0.svg";
export { ForwardRef as ReactComponent };